module.exports = __webpack_public_path__ + "static/img/rocky.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/rocky.jpg
// module id = SPON
// module chunks = 0